import { lazy, Suspense, useEffect } from 'react';
import { Navigate } from 'react-router';
import { useMe } from '@/features/auth/hooks.js';
import { LandingSkeleton } from './components/LandingSkeleton.js';

const LandingPage = lazy(() =>
  import('./LandingPage.js').then((m) => ({ default: m.LandingPage })),
);

export function LandingRoute() {
  const me = useMe();

  // Skeleton dark no cold start em vez de `null` (#148): mata o flash branco
  // do first-paint sem o flash inverso que renderizar a landing direto causaria
  // pro logado.
  if (me.isLoading) return <LandingSkeleton />;
  // me.isError cai pra LandingPage de propósito: graceful degrade quando /me
  // está fora — anon view é o padrão seguro pra rota /. ConnectPage tem
  // escape hatch `!errorCode` pra OAuth callback; aqui não, callbacks nunca
  // pousam em /.
  if (me.isSuccess && me.data) return <Navigate to="/painel" replace />;

  return <LandingShell />;
}

function LandingShell() {
  // Marca o <html> com `is-landing` para escopar `scroll-behavior: smooth`
  // só à landing (sem vazar pra /painel onde react-virtuoso usa scrollTo).
  useEffect(() => {
    document.documentElement.classList.add('is-landing');
    return () => document.documentElement.classList.remove('is-landing');
  }, []);

  return (
    <Suspense fallback={<LandingSkeleton />}>
      <LandingPage />
    </Suspense>
  );
}
